import { axiosInstanceV2 } from "@src/shared/api";
import { useAuthStore } from "@src/entities/login/model/store/authStore";
import { RATING_API_URL } from "../constants";

interface ISendReviewRequestDto {
  user_id: number;
  text: string;
}

export const sendReview = (data: ISendReviewRequestDto) => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;
  return axiosInstanceV2.post(RATING_API_URL.getReviewUrl(), data, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};
